const CommentsLoading = () => {
  return <></>;
};

export default CommentsLoading;
